// @flow

/**
 * Module dependencies.
 */

import { branch } from 'core/utils';
import { fixedHeight, setStylesProp } from 'client/styles';
import styled from 'styled-components';

/**
 * `PageContent` component.
 */

const PageContent = styled.div`
  min-height: 100vh;
  padding-bottom: ${fixedHeight.footer};

  ${({ background }) => branch(background, `background-color: ${background};`)}
  ${setStylesProp};
`;

/**
 * Export `PageContent`.
 */

export default PageContent;



// WEBPACK FOOTER //
// ../src/client/components/core/page-content.js